import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { MustMatch } from './old-pwd.validators';
import { EnvService } from '../../../services/env.service';
import { USER_MGMT_CNST, USER_MGMT_DEFAULT_CONFIG_CNST } from '../../../constants/proj.cnst';
import { AppStateService } from '../../../services/app-state.service';
import { HttpService } from '../../../services/http.service';
import { UtilsService } from '../../../services/utils.service';
import { isNullOrUndefined } from '../../shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  submitted: boolean = false;
  userInfo: any = {};
  error: any;
  displayErrorMessage: any;
  hidePassword: boolean = true;
  activespiner: boolean = false;
  changePasswordConfig: any = {}
  constant: any = {}
  hideChangePassword: boolean = true;

  constructor(
    fb: FormBuilder,
    private utilsServ: UtilsService,
    private router: Router,
    private appState: AppStateService,
    private authSrv: AuthenticationService,
    private httpSrv: HttpService,
    private envService : EnvService,
    public activeModal: NgbActiveModal,
    private dialog:MatDialog
  ) {
    this.forgotPasswordForm = fb.group({
      'newPwd': ['', [Validators.required, Validators.minLength(11),this.passwordValidator]],
      'confirmPwd': ['', Validators.required]
    },
    {
      validator: MustMatch('newPwd', 'confirmPwd')
    });
  }
  passwordValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{11,50}$/;
    if (control.value && !passwordPattern.test(control.value)) {
      return { 'invalidPassword': true };
    }
    return null;
  }

  get formControl() {
    return this.forgotPasswordForm.controls;
  }

  ngOnInit() {
    this.constant = USER_MGMT_DEFAULT_CONFIG_CNST.CHANGE_PSWD_CONST
  }

  // Returning post parameters for OTP sending API
  getPostParams() {
    const postData = {
      username: this.authSrv.getUserName()
    }
    return postData
  }
  logout() {
    this.authSrv.setUserInfo(null, ("null" as string));
    this.appState.setPermissionsLoaded(false);
    this.appState.setInProcess(false);
    this.appState.setUserMetaInfo({});
    this.appState.setUserPermissionsRef({});
    this.router.navigate(USER_MGMT_CNST.COMMON_ROUTE_MAPPING.LOGIN);
  }
  //Submitting data
  handleChangePassword() {
    this.activespiner = true;
    this.submitted = true;

    if (this.forgotPasswordForm.invalid) {
      this.activespiner = false;
    } else{
      let newPassword = this.forgotPasswordForm.value['newPwd'];
      let confirmNewPassword = this.forgotPasswordForm.value['confirmPwd'];
  
      if (newPassword != confirmNewPassword) {
        this.activespiner = false;
        this.displayErrorMessage = "Password Does not Match";
      }else{
        let userMetaInfo = this.appState.getUserMetaInfo();
        if (this.utilsServ.isObjectNotNullAndEmpty(userMetaInfo)) {
          let { userId = null } = userMetaInfo;
    
          if (!isNullOrUndefined(userId)) {
            let postData = {
              "type": "password",
              "value": newPassword,
              "userId": userId,
              "temporary": false,
              "removeAction":false
            }
    
            this.httpSrv.makePutApiCall('KEYCLOAK_RESET_PASSWORD', postData, this.envService.baseUrl).subscribe({
              next: (response: any) => {
                this.submitted = false;
                let { result ,statusCode,message} = response;
                if(statusCode === 200){
                  this.utilsServ.showToastMessage("Password changed successfully", "success");
                  setTimeout(() => {
                    if (result) {
                      this.utilsServ.logout();
                    }
                  }, 500);
                  this.closeDialog();
                }else{
                  this.utilsServ.showToastMessage(message, "error");
                }
    
              },
              complete: () => {},
              error: (err: any) => {
                this.submitted = false;
                this.utilsServ.showToastMessage("Error in resetting password", "error");
                console.log("Error in resetting password", err);
                // this.activeModal.close()
                this.closeDialog();
              }
            });
          }
        }
      }
    }

  }

  isErrorsExist(){
    if(this.forgotPasswordForm.invalid || this.forgotPasswordForm.value['newPwd'] != this.forgotPasswordForm.value['confirmPwd']){
        return true;
    } else{
     return false;
    }
  }
  onEnterPressed(){
    if(!this.isErrorsExist()){
      this.handleChangePassword();
    }
  }
  closeDialog(){
    this.dialog.closeAll();
  }
  notAllowSpace(event: any) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
    }
  }

}
